import { type ReactNode } from "react";
import { useAuth } from "@/lib/auth";
import { Login } from "@/pages/Login";

/** Gates the entire app behind a session. Shows a spinner while the
 *  initial /auth/me check is in flight, the login screen when there's
 *  no session, and the app once authenticated. */
export function AuthGate({ children }: { children: ReactNode }) {
  const { status } = useAuth();

  if (status === "loading") {
    return (
      <div className="flex h-screen items-center justify-center bg-canvas">
        <div className="text-sm text-ink-subtle">Loading…</div>
      </div>
    );
  }

  if (status === "anon") {
    return <Login />;
  }

  return <>{children}</>;
}
